import { useToast } from 'context/providers/ToastProvider';
import useToken from 'hooks/useToken';
import { useState } from 'react';

/**
 * Hook personalizado para manejar todas las llamadas API relacionadas con gastos
 */
const useGastoAPI = () => {
    const { token, setToken } = useToken();
    const { showErrorToast, showSuccessToast } = useToast();

    const [formasdePago, setFormasdePago] = useState([]);
    const [cuentasBancarias, setCuentasBancarias] = useState([]);
    const [responsableUsuario, setResponsableUsuario] = useState([]);
    const [tipoDeGasto, setTipoDeGasto] = useState([]);

    /**
     * Obtiene el tipo de gasto
     */
    const obtenerTipoDeGasto = async () => {
        try {
            const response = await fetch("/api/Gastos/obtenerTipoDeGasto", {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                const data = await response.json();

                if (data.iResponseType == 1) {
                    var ObjDetalles = JSON.parse(data.detalles);
                    setTipoDeGasto(ObjDetalles.table2);
                } else {
                    showErrorToast(data.vMessage);
                }
            } else {
                showErrorToast(response.status + ' ' + response.statusText);
                if (response.status == 401) {
                    setToken(null);
                    location.href = "";
                }
            }
        } catch (error) {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            console.log('Hubo un problema con la peticion Fetch:' + error);
        }
    };

    /**
     * Obtiene los usuarios responsables
     */
    const obtenerResponsableGasto = async () => {
        try {
            const response = await fetch("/api/Gastos/obtenerResponsableGasto", {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                const data = await response.json();

                if (data.iResponseType == 1) {
                    var ObjDetalles = JSON.parse(data.detalles);
                    setResponsableUsuario(ObjDetalles.table2);
                } else {
                    showErrorToast(data.vMessage);
                }
            } else {
                showErrorToast(response.status + ' ' + response.statusText);
                if (response.status == 401) {
                    setToken(null);
                    location.href = "";
                }
            }
        } catch (error) {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            console.log('Hubo un problema con la peticion Fetch:' + error);
        }
    };

    /**
     * Obtiene las cuentas bancarias
     */
    const obtenerCuentasBancarias = async () => {
        try {
            const response = await fetch("/api/Gastos/obtenerCuentasBancarias", {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                const data = await response.json();

                if (data.iResponseType == 1) {
                    var ObjDetalles = JSON.parse(data.detalles);
                    setCuentasBancarias(ObjDetalles.table2);
                } else {
                    showErrorToast(data.vMessage);
                }
            } else {
                showErrorToast(response.status + ' ' + response.statusText);
                if (response.status == 401) {
                    setToken(null);
                    location.href = "";
                }
            }
        } catch (error) {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            console.log('Hubo un problema con la peticion Fetch:' + error);
        }
    };

    /**
     * Obtiene las formas de pago
     */
    const obtenerFormasdePago = async () => {
        try {
            const response = await fetch("/api/Gastos/obtenerFormasdePago", {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                const data = await response.json();

                if (data.iResponseType == 1) {
                    var ObjDetalles = JSON.parse(data.detalles);
                    setFormasdePago(ObjDetalles.table2);
                } else {
                    showErrorToast(data.vMessage);
                }
            } else {
                showErrorToast(response.status + ' ' + response.statusText);
                if (response.status == 401) {
                    setToken(null);
                    location.href = "";
                }
            }
        } catch (error) {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            console.log('Hubo un problema con la peticion Fetch:' + error);
        }
    };

    /**
     * Registra o actualiza un gasto
     */
    const registrarGasto = async (gastoData, callbacks) => {
        const {
            setGuardando,
            setEditar,
            setCargando,
            setSelectedGasto,
            setShowModalRegistrarGasto,
            setGastos,
            setUltimoGasto
        } = callbacks;

        setGuardando(true);

        try {
            const response = await fetch("/api/Gastos/registrarGasto", {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(gastoData)
            });

            if (response.ok) {
                setGuardando(false);
                setEditar(false);

                const data = await response.json();
                setCargando(false);

                if (data.iResponseType == 1) {
                    setSelectedGasto({});
                    showSuccessToast(data.vMessage);

                    var ObjDetalles = JSON.parse(data.detalles);
                    setShowModalRegistrarGasto(false);

                    const gastoActualizado = ObjDetalles.table2[0];

                    // Verificar si es una actualizaci�n (idGasto > 0) o un nuevo registro
                    if (gastoData.idGasto && gastoData.idGasto > 0) {
                        // Es una actualizaci�n: reemplazar el gasto existente en la lista
                        setGastos((prevGastos) => 
                            prevGastos.map(gasto => 
                                gasto.idGasto === gastoActualizado.idGasto 
                                    ? gastoActualizado 
                                    : gasto
                            )
                        );
                    } else {
                        // Es un nuevo gasto: agregarlo al principio de la lista
                        setGastos((prevGastos) => [gastoActualizado, ...prevGastos]);
                    }

                    const UltimoGasto = ObjDetalles.table2.length > 0 ? ObjDetalles.table2[0] : null;

                    setUltimoGasto({
                        idTipoGasto: UltimoGasto.idTipoGasto,
                        idCatFormaPago: UltimoGasto.idCatFormaPago,
                        vTipoFactorIva: UltimoGasto.vTipoFactorIva
                    });
                } else {
                    showErrorToast(data.vMessage);
                }
            } else {
                setGuardando(false);
                showErrorToast(response.status + ' ' + response.statusText);
                if (response.status == 401) {
                    setToken(null);
                    location.href = "";
                }
            }
        } catch (error) {
            setGuardando(false);
            showErrorToast('Hubo un problema con la peticion: ' + error);
            console.log('Hubo un problema con la peticion:', error);
        }
    };

    /**
     * Inicializa todas las llamadas API necesarias
     */
    const inicializarDatos = () => {
        obtenerTipoDeGasto();
        obtenerFormasdePago();
        obtenerCuentasBancarias();
        obtenerResponsableGasto();
    };

    return {
        formasdePago,
        cuentasBancarias,
        responsableUsuario,
        tipoDeGasto,
        registrarGasto,
        inicializarDatos
    };
};

export default useGastoAPI;
